<template>
  <v-row class="pa-0 ma-0 color-black">
    <v-col cols="12" v-for="(item, allDataNum) in allData" :key="allDataNum"
    class="pa-0 ma-0">
      <template 
      v-if=" item.componentType === 'title' ||
      item.componentType === 'min-title' ||
      item.componentType === 'text' ||
      item.componentType === 'list' ||
      item.componentType === 'iframe' ||
      item.componentType === 'pdf' ||
      item.componentType === 'hr' ||
      item.componentType === 'nullData' ||
      item.componentType === 'big-nullData' ||
      item.componentType === 'img' ||
      item.componentType === 'labintro' ||
      item.componentType === 'sdgs' ||
      item.componentType === 'bordered-text' ||
      item.componentType === 'video'" >
        <textComponent
           class="px-1"
          :all-data="item"
          :title-style="titleStyle"
          :subhead-style="subheadStyle"
          :text-alignment="textAlignment"
        />
      </template>

      <template v-if="item.componentType === 'swapTextAndImg'">
        <v-row id="textBox-two" cols="12" class="ma-0 pa-0">
          <v-col cols="12" v-for="(item2, sTAINum) in item.data" :key="sTAINum" class="pa-0 pt-4 pt-md-8 mt-4 mt-md-8 mb-md-8">
            <!-- 根據 item.layout 來調整排列方式 -->
            <v-row class="mx-0 pa-0" :class="[sTAINum % 2 === 0 ? '':'flex-md-row-reverse',
            sTAINum.length-1 == sTAINum? 'mb-8':'mb-0']">
              <v-col cols="12" md="6" class="pa-0 pa-md-3">
                <v-img aspect-ratio="1.7" contain :alt="`${t(item2.title)}形象圖`"
                 :src="require(`../../public/tools/img/${item2.imgLink}`)">
                </v-img>
              </v-col>
              <v-col cols="12" md="6" class="d-flex align-center justify-center mx-0" >
                  <div class="textBox pa-0 mt-2">
                    <h3 class="te-h3-B mt-5 mt-md-0 mb-4 pa-0 text-justify" :class="`${subheadStyle}`">{{ t(item2.title) }}</h3>
                    <template>
                      <div v-for="(content, contentIndex) in item2.contents" :key="contentIndex">
                        <p class="te-p mb-2 color-te-B text-justify" >{{ t(content.text) }}</p>
                      </div>
                    </template>
                    <div class="more-txt w-100 d-flex justify-end align-center pa-0" v-if="item2.link">
                      
                      <a class="ma-2 color-btn font-B rounded-pill icon16"
                        @click="$router.push({
                        path: item2.link.link,
                        query: {
                          tag: item2.link.title,
                        },
                        })"
                        :href="`${item2.link.link}?tag=${item2.link.title}`"
                        :title="`更多${t(item2.link.title)}資訊`">
                        {{ t('more') }}
                        <i class="ml-2 fa-solid fa-angles-right"></i>
                      </a>
                    </div>
                  </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>


      <template v-if="item.componentType === 'twoObjects'">
        <v-row id="textBox-two" cols="12" class="ma-0 pa-0 w-100">
          <v-col cols="12" class="pa-0 pt-4 pt-md-0  mt-4 mt-md-0">
            <v-row class="mb-8 mx-0 pa-0">
              <v-col cols="12" md="6" width="100%" class="pa-0 pa-md-3">
                <div v-for="(lD , lDataMum) in item.leftData" :key="lDataMum">
                  <textComponent
                    :all-data="lD"
                    :title-style="`${titleStyle} pt-0`"
                    :subhead-style="`${subheadStyle} pt-0`"
                    :text-alignment="'left'"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6" width="100%" class="pa-0 pa-md-3">
                <div v-for="(rD , rDataMum) in item.rightData" :key="rDataMum">
                  <textComponent
                    :all-data="rD"
                    :title-style="`${titleStyle} pt-0`"
                    :subhead-style="`${subheadStyle} pt-0`"
                    :text-alignment="'left'"
                  />
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>

      <template v-if="item.componentType === 'NumberedContentBox'">
        <v-container>
          <v-row>
            <v-col cols="12" md="10" xl="8" class="feature-container">
              <div v-for="(contentItem, index) in item.data" :key="index" class="feature-item">
                <div class="item-header">
                  <span class="item-number">{{ contentItem.number }}</span>
                  <img :src="contentItem.img" :alt="`Image for ${contentItem.number}`" class="item-image"/>
                </div>
                <p class="item-text pr-4" v-html="formatText(contentItem.text)"></p>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-if="item.componentType === 'CompanyList'">
        <div class="company-list">
          <div class="company-card" v-for="(company, index) in item.data" :key="index">
            <div class="logo-container">
              <img :src="company.logo" alt="Company Logo" class="company-logo" />
            </div>
            <p class="company-name">{{ company.name }}</p>
          </div>
        </div>
      </template>

      <template v-if="item.componentType === 'CareerPath'">
        <div class="masonry-grid">
          <div
            v-for="(career, index) in item.data"
            :key="index"
            class="masonry-item"
          >
            <div class="career-card">
              <h3 class="career-title">{{ career.job }}</h3>
              <p class="career-description">{{ career.content }}</p>
            </div>
          </div>
        </div>
      </template>

      <template v-if="item.componentType === 'table'">
        <div class="table-container">
          <div class="table-title">{{ item.title }}</div>
          <table>
            
            <thead>
              <tr>
                <th v-for="(column, index) in item.columns" 
                  :key="column.key" 
                  :style="{ width: column.width }" 
                  :class="getHeaderClass(index)">
                  {{ column.label }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rowIndex) in item.data" :key="rowIndex">
                <td 
                  v-for="(column, index) in item.columns" 
                  :key="column.key" 
                  :style="{ width: column.width , textAlign: getAlign(column) }" 
                  :class="getCellClass(index)"
                  v-html="formatText(row[column.key])">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </template>

    </v-col>
    
  </v-row>
</template>

<script>
import textComponent from '../components/textComponent.vue'; // 导入文本组件
import axios from 'axios';


export default {
  data() {
    return {
      careers: []
    };
  },
  props: [
    "allData",
    "titleStyle",
    "subheadStyle",
    "textAlignment",
    "data",
    "title",,
    "colums",
  ],
  components: {
    textComponent,
  },
  created() {
    // 使用 axios 從 JSON 文件獲取數據
    axios.get('/tools/json/occupation.json')
      .then(response => {
        this.careers = response.data;
      })
      .catch(error => {
        console.error("Error loading careers data:", error);
      });
  },
  methods: {
    formatText(text) {
      // 將 /n 換行符號替換為 <br>
      return text.replace(/\/n/g, "<br>");
    },
    getHeaderClass(index) {
      // Return a class name based on the index of the column
      return `header-cell col-${index}`;
    },
    getCellClass(index) {
      // Return a class name based on the index of the column
      return `data-cell col-${index}`;
    },
        getAlign(column) {
      // Adjust this method to return appropriate text alignment for cells
      return column.align || 'left';
    }
  }
};
</script>


<style lang="scss">
.myP{
  width: fit-content;
}

.bannerSubtitle::after {
  content: "\00A0"; /* 使用 Unicode 表示半角空格 */
}


.feature-container {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;  /* 讓所有 .feature-item 居中 */
  justify-content: center;
  width: 80%; /* 設置寬度以便內容置中 */
  margin: 0 auto; /* 讓整個 .feature-container 水平置中 */
}

.feature-item {
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  text-align: left;
  flex-wrap: wrap;
  width: 100%; /* 讓每個 feature-item 占滿容器寬度 */
  max-width: 1200px; /* 可選：限制每個 item 的最大寬度 */
}

.item-header {
  display: flex;
  align-items: center;
  justify-content: center; /* 保持圖片和編號居中 */
}

.item-number {
  font-size: 72px;
  font-weight: bold;
  color: #1f4e9b;
  padding-left:20px;
}

.item-image {
  width: 200px; /* 預設寬度 */
  height: auto;
}

/* 當螢幕寬度變小時，調整圖片大小 */
@media (max-width: 1200px) {
  .item-image {
    width: 150px;
  }
}

@media (max-width: 768px) {
  .item-image {
    width: 125px;
  }
  .item-number {
  font-size: 48px;
  }
}

.item-text {
  line-height: 1.5;
  color: #333;
  flex: 1; /* 讓文字部分佔據剩餘空間 */
  text-align: center;
  margin-top: 10px; /* 增加文字和圖片之間的間距 */
}

.company-list {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.company-card {
  width: 23%;
  text-align: center;
  margin: 0 5px 20px 5px;
}

@media (max-width: 768px) {
  .company-card {
    width: 30%;
  }
}

.logo-container {
  height: 150px; /* 固定高度 */
  background-color: white; 
  display: flex;
  align-items: center; 
  justify-content: center; 
  padding: 10px;
}

.company-logo {
  max-height: 100%; 
  max-width: 100%;
}

.company-name {
  margin-top: 10px;
  font-size: 16px;
}

.masonry-grid {
  column-count: 4; /* 這裡控制顯示幾列 */
  column-gap: 15px; /* 控制每列之間的間距 */
  max-width: 1000px;
  margin: 0 auto; /* 置中 */
}

@media (max-width: 1200px) {
  .masonry-grid {
    column-count: 3; /* 小螢幕時顯示2列 */
    column-gap: 15px; /* 小螢幕時調整間距 */
  }
}

@media (max-width: 768px) {
  .masonry-grid {
    column-count: 2; /* 小螢幕時顯示2列 */
    column-gap: 10px; /* 小螢幕時調整間距 */
  }
}

.masonry-item {
  break-inside: avoid; /* 防止元素被截斷 */
  margin-bottom: 15px; 
}

.career-card {
  background-color: var(--primary); /* 深藍色背景 */
  color: #fff; /* 白色字體 */
  padding: 20px;
  border-radius: 10px; /* 圓角 */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* 輕微陰影 */
  text-align: center;
  display: inline-block; /* 讓每個卡片的長度根據內容自動調整 */
  width: 100%;
}

.career-title {
  background-color: white;
  color: #003b73;
  font-size: 16px;
  font-weight: bold;
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 10px;
}

.career-description {
  font-size: 14px;
  line-height: 1.6;
  text-align: left;
}

.text-blue {
  color: #3498db;
}

.icon-image {
  max-width: 100%; 
  height: auto;
}

.table-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 20px 0;
}

.table-title {
  text-align: center;
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 10px; /* 表格和标题之间的间距 */
}

table {
  border-collapse: collapse;
  width: 90%; /* 确保表格宽度适应容器 */

  @media only screen and (max-width: 768px) {
  width: 100%;
  }
}

th.header-cell, td.data-cell {
  padding: 12px;
  border: 1px solid #ddd;
}

th.header-cell {
  text-align: center; /* 统一置中表头 */
  background-color: #1e93c9; /* 可选: 背景色 */
  color: #f4f4f4;
}

td.data-cell {
  text-align: left; /* 默认左对齐单元格 */
}

tbody tr:nth-child(even) {
  background-color: #f9f9f9; /* 偶数行背景色 */
}

tbody tr:nth-child(odd) {
  background-color: #ffffff; /* 奇数行背景色 */
}

th, td {
  text-align: left; /* 单元格内容对齐 */
}
</style>